var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var GisDatastoreService = /** @class */ (function (_super) {
            __extends(GisDatastoreService, _super);
            function GisDatastoreService(injectedBreeze, $q, $http) {
                var _this = _super.call(this, injectedBreeze, $q) || this;
                _this.$http = $http;
                return _this;
            }
            GisDatastoreService.prototype.createGeometryDatastoreType = function () {
                return this.createNewEntity("GeometryDatastoreType");
            };
            GisDatastoreService.prototype.createGisDatastore = function () {
                return this.createNewEntity("GisDatastore");
            };
            GisDatastoreService.prototype.getGisDatastores = function () {
                var query = this.breezeModule.EntityQuery
                    .from("GisDatastores")
                    .expand("availableDatastoreTypes");
                return this.executeQuery(query);
            };
            GisDatastoreService.prototype.activate = function (gisDatastoreId) {
                var d = this.$q.defer();
                this.$http.post('./api/GisDatastore/' + gisDatastoreId + '/Activate', null).then(function (r) {
                    d.resolve();
                });
                return d.promise;
            };
            GisDatastoreService.prototype.queryGisDatastore = function (gisDatastore, placeholderValueDictionary, queryConfiguration, geometryPlaceholder) {
                var d = this.$q.defer();
                var geoJson = null;
                if (geometryPlaceholder && geometryPlaceholder.type) {
                    geoJson = geometryPlaceholder;
                }
                else if (geometryPlaceholder) {
                    geoJson = geometryPlaceholder.toGeoJSON();
                }
                /* if (queryConfiguration) {
                     if (!placeholderValueDictionary) {
                         placeholderValueDictionary = {};
                     }
     
                     queryConfiguration.wherePredicates.forEach(f => {
                         let value = "";
                         if (f.value) {
                             value = f.value;
                         }
     
                        if (!f.isPlaceholder) {
                            placeholderValueDictionary[`Metadata${f.metadataNumber}`] = value;
                        }
                     });
                 }*/
                var data = {
                    geoJson: geoJson,
                    placeHolders: placeholderValueDictionary
                };
                this.$http.post("api/GisDatastore/" + gisDatastore.id + "/Query/" + queryConfiguration.id, data).then(function (f) {
                    d.resolve(f.data);
                });
                return d.promise;
            };
            return GisDatastoreService;
        }(services.DataService));
        services.GisDatastoreService = GisDatastoreService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService('GisDatastoreService', ['breeze', '$q', '$http']);
